export default function FilterDataByRoute(){

    const route = useRoute();
    
    const getFixed = () => {
        if(!route.path.includes('/oglasi')) return false;
       
           return route.params.page.toString().includes('-') ? route.params.page.includes('fiksno') ? true : false : false;
     } 

    
     const getBuying = () => {
        if(!route.path.includes('/oglasi')) return null;

        let find  = route.params.page.toString().includes('-') ? route.params.page.split('-').filter(x=> x == 'kupujem' || x == 'prodajem') : null;

        return find != null ? find[0] : null;
     } 
    
     const getType= () => {
        if(!route.path.includes('/oglasi')) return null;

        let find = route.params.page.toString().includes('-') ? route.params.page.split('-').filter(x=> x == 'cena' || x == 'dogovor') : null;
       

        return find != null ? find : null;
     } 

     const getPage= () => {

      //   if (!route.path.includes('/oglasi')) {
      //         return 1
      //       }
          
            // uzmi raw vrednost iz parametara (može biti npr. "filter1-filter2-3" ili samo "2")
            const raw = String(route.params.page ?? 1)
          
            const segments = raw.split('-')
            const lastSegment = segments[segments.length - 1]
          
            const page = parseInt(lastSegment, 10)
           
            // fallback: ako nije validan broj ili je manje od 1 → 1
            if (Number.isNaN(page) || page < 1) {
              return 1
            }
                   
                  

        return parseInt(page);
     } 
     const arrToStringWithJoin = (arr) => {

        return arr.toString().split(',').join('-');
     } 
     const getArrayOfParams = () => {

        if(!route.path.includes('/oglasi')) return [];

        return route.params.page.toString().includes('-') ? route.params.page.split('-').slice(0, route.params.page.split('-').length-1) : [];  
     } 

    
    return {
        getFixed,
        getBuying,
        getType,
        getPage,
        arrToStringWithJoin,
        getArrayOfParams
    }
}
